export default function recaptchaHandler() {
    const ok = Boolean(window.recaptcha_ok)

    document.querySelectorAll('.recaptcha').forEach(($recaptcha) => {
        if (ok) {
            $recaptcha.classList.remove('recaptcha--error');
        }    else {
            $recaptcha.classList.add('recaptcha--error');
        }
    })

    return Boolean(window.recaptcha_ok);
}